import { FunctionComponent, PropsWithChildren } from "react";
import { Button } from "../button/Button.component";
import { ButtonClass } from "../../enums/ButtonClass";
import { ButtonMenu } from "../button-menu/ButtonMenu.component";
import { Icon } from "../icon/Icon.component";
import { chevronIcon } from "../icon/icons/Chevron.icon";
import { ISplitButtonProps } from "./interfaces/ISplitButtonProps";
import "./styles/split-button.css";

export const SplitButton: FunctionComponent<PropsWithChildren<ISplitButtonProps>> = (props) => {
    return (
        <div className="cui-split-button">
            <Button
                className={`${ButtonClass.Contained} cui-split-button__button`}
                onClick={props.onClick}
                disabled={props.disabled}
                dataHook={props.buttonDataHook}
                ariaLabel={props.buttonLabel}>
                {props.children}
            </Button>
            <ButtonMenu
                buttonStyle={`${ButtonClass.Contained} cui-split-button__dropdown`}
                selectOptions={props.selectOptions}
                disabled={props.disabled}
                buttonDataHook={props.buttonMenuDataHook}
                ariaLabel={props.dropdownLabel}
                placement="bottom-end">
                <Icon className="cui-split-button__icon" source={chevronIcon} />
            </ButtonMenu>
        </div>
    );
};
